import React, { useState, useEffect } from 'react';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { toast, ToastContainer } from 'react-toastify';
import arrowIcon from '../../assets/img/arrow-right.svg';
import copyIcon from '../../assets/img/copy.svg';
import 'react-toastify/dist/ReactToastify.css';
import { SmoothScrollLink } from '../../utils/navUtils';
import './bottomBanner.scss';

function BottomBanner() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const [isCopied, setIsCopied] = useState(false);
    const textToCopy = 'CLOUD15';

    useEffect(() => {
        if (isCopied) {
            toast.success('Copied!', {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: 'light'
            });

            setTimeout(() => setIsCopied(false), 2000);
        }
    }, [isCopied]);

    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setIsCopied(true);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <div className="bottom-banner-wrapper">
            <ToastContainer />
            <Container>
                <div className="bottom-banner">
                    <div className="banner-discount">
                        <span className="number">{currentLanguage === 'fr' ? '-15' : '15'}</span>
                        <span className="percent">
                            %<br />
                            {currentLanguage === 'fr' ? '' : 'off'}
                        </span>
                    </div>
                    <div className="banner-info">
                        <h3
                            className="info-title"
                            dangerouslySetInnerHTML={{ __html: t('home-page.bottom-banner.title') }}
                        />
                        <p className="info-text">{t('home-page.bottom-banner.text')}</p>
                        <div className="info-promo">
                            {t('home-page.bottom-banner.text-2')}
                            <button
                                className="info-promo-button"
                                onClick={handleCopy}
                                type="button"
                            >
                                {textToCopy}
                                <img src={copyIcon} alt="Copy" />
                            </button>
                        </div>
                    </div>
                    <div className="banner-action">
                        <Nav>
                            <SmoothScrollLink to={localizedPath('/hosting/web#plans-section')}>
                                <Navbar.Brand>
                                    {t('buttons.see-plans')} <img src={arrowIcon} alt="See plans" />
                                </Navbar.Brand>
                            </SmoothScrollLink>
                        </Nav>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default BottomBanner;
